<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-5.col-4.mb-1
        b-input-group(size="sm")
          b-form-select.col-4(v-model="searchType" size="sm" @change="initSearchData()")
            option(value="account_id") {{ $t("ui.account_id") }}
            option(value="bank_acc_no") {{ $t("ui.bank_acc_no") }}
          DebounceInput(autofocus type="text" v-model="searchData" :placeholder="$t('message.search_by_' + searchType)" @enter="getBankMbmList(true)" size="sm")
      .form-group.col-md-7.col-12
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getBankMbmList(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12 
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="7%" @click="sortOrder('account_id')")
                  span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                  .float-right
                    i(:class="changeSortKey('account_id')")
                th(width="5%")
                  span(:title="$t('ui.category')") {{ $t("ui.category") }}
                th(width="15%")
                  span(:title="$t('ui.bank_name')") {{ $t("ui.bank_name") }}
                th(width="10%" @click="sortOrder('bank_acc_no')")
                  span.d-block(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                  span(:title="$t('ui.crypto_address')") {{ $t("ui.crypto_address") }}
                  .float-right
                    i(:class="changeSortKey('bank_acc_no')")
                th(width="20%" @click="sortOrder('bank_acc_holder')")
                  span.d-block(:title="$t('ui.bank_acc_holder')") {{ $t("ui.bank_acc_holder") }}
                  span(:title="$t('ui.crypto_network')") {{ $t("ui.crypto_network") }}
                  .float-right
                    i(:class="changeSortKey('bank_acc_holder')")
                template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                  th.text-left(width="7%")
                    span(:title="['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit')") {{ ['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit') }}
                  th.text-left(width="7%" v-if="['AUD'].includes(getCurrencyCode)")
                    span(:title="$t('ui.payid')") {{ $t("ui.payid") }}
                th.text-center.sticky-toggle(width="5%" @click="sortOrder('status')")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                  .float-right
                    i(:class="changeSortKey('status')")
                th.text-center(width="5%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                th.text-right(width="15%")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
            tbody.clusterize-content
              tr(v-if="bankMbmList.length == 0")
                td(:colspan="isEditAccess ? '12' : '10'").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in bankMbmList" :class="$helpers.rowClassBit(item.status)")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.account_id") {{ item.account_id }}
                td
                  span(:title="item.category") {{ item.category }}
                td
                  span(:title="item.bank_name") {{ item.bank_name }}
                  .fas.fa-check-circle.text-success.ml-1(v-if="item.bank_name && item.is_default" :title="$t('ui.default')")
                td
                  span(:title="item.bank_acc_no") {{ item.bank_acc_no }}
                td
                  span(:title="item.bank_acc_holder") {{ item.bank_acc_holder }}
                template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
                  td
                    span(:title="item.remark") {{ item.remark }}
                  td(v-if="['AUD'].includes(getCurrencyCode)")
                    span(:title="item.remark_2") {{ item.remark_2 }}
                td
                  div.d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="!isEditAccess ? null : changedBankMbmStatus(item, $event)" :disabled="!isEditAccess")
                      span.custom-switch-indicator
                td.text-center.actions(v-if="isEditAccess")
                  span
                    a.fa.fa-lg.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                td.text-right
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

    editbankmember(ref="editbankmember" :item="editSelectedBankMember" @clicked="afterEditBankMember" @failed="handleFailed")
    //- editbankmemberewallet(ref="editbankmemberewallet" :item="editSelectedBankMember" @clicked="afterEditBankMember" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editbankmember from "@/components/payment/editBankMember.vue";
// import editbankmemberewallet from "@/components/payment/editBankMemberEWallet.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editbankmember,
    // editbankmemberewallet
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentPage: 1,
    totalRow: 0,
    searchType: "bank_acc_no",

    bankMbmList: [],
    searchData: "",
    editSelectedBankMember: null,
    sortKey: "account_id",
    sortType: "asc",
    filterBy: "account_id",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeBankMember;
    },
    accountType() {
      return this.$store.getters.accountType;
    },   
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_bankmember");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
  },
  methods: {
    refresh() {
      // this.getBankMbmList();
    },
    initSearchData() {
      this.searchData = '';
      this.totalRow = 0;
      this.bankMbmList = [];
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getBankMbmList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    onEdit(e) {
      this.editSelectedBankMember = e;
      this.$refs.editbankmember.$refs.editBankMember.show();
      // if(e.category == 'BANK') {
      //   this.$refs.editbankmember.$refs.editBankMember.show();
      // } else {
      //   this.$refs.editbankmemberewallet.$refs.editBankMemberEWallet.show();
      // }
    },
    afterEditBankMember: function(item) {
      this.getBankMbmList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_bank_member"), this.$t("message.success"), "success");
    },
    getBankMbmList: function(isSearch) {
      if (this.searchData.trim() != '') {
        let url = config.bankMemberListUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        if (this.searchData.trim() != '') {
          if (this.searchType == "account_id") {
            json.member_id = this.searchData.trim();
          } else if (this.searchType == "bank_acc_no") {
            json.bank_acc_no = this.searchData.trim();
          }
        }

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.bankMbmList = response.data.dt;
                  this.totalRow = this.bankMbmList.length > 0 ? this.bankMbmList[0].totalrows : 0;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.totalRow = 0;
        this.bankMbmList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.searchCriteriaRequired"), "error");
      }
    },
    changedBankMbmStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_bank_account_status_confirm", { name: item.bank_acc_no }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBankMbmStatus(item, eventStatus.srcElement.checked);
          } else {
            this.getBankMbmList();
          }
        });
    },
    confirmBankMbmStatus: function(item, status) {
      let url = config.bankMemberStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: item.account_id,
        bank_id: item.bank_id,
        bank_acc_no: item.bank_acc_no,
        new_status: status,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                item.status = status;
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getBankMbmList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeBankMember", pageSize);
      this.currentPage = 1;
      this.getBankMbmList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getBankMbmList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
  